function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon-star");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Pages",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Detail",
  transform: "translate(-1213.000000, -689.000000)",
  fill: "currentColor",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Actions",
  transform: "translate(1143.000000, 680.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Star",
  transform: "translate(60.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon-star",
  transform: "translate(9.000000, 9.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.1,19.98 C5.76213339,20.157663 5.35259539,20.1274771 5.0444287,19.9021966 C4.73626201,19.6769161 4.58323252,19.2958459 4.65,18.92 L5.68,12.89 L1.3,8.63 C1.0245288,8.36382475 0.925315417,7.96367647 1.04453143,7.59964187 C1.16374743,7.23560727 1.48044155,6.97166261 1.86,6.92 L7.91,6.04 L10.61,0.56 C10.7770864,0.215009671 11.1266774,-0.00411010565 11.51,-0.00411010565 C11.8933226,-0.00411010565 12.2429136,0.215009671 12.41,0.56 L15.11,6.04 L21.17,6.92 C21.5435096,6.97763 21.8526214,7.24090608 21.9689557,7.60048491 C22.08529,7.96006375 21.9889704,8.35450885 21.72,8.62 L17.34,12.89 L18.38,18.92 C18.4496284,19.2987305 18.2956063,19.6837936 17.9839955,19.9100316 C17.6723847,20.1362695 17.2585541,20.1634831 16.92,19.98 L11.52,17.13 L6.1,19.98 Z M11.05,15.11 C11.3411417,14.9570809 11.6888583,14.9570809 11.98,15.11 L16.06,17.26 L15.28,12.71 C15.226743,12.3868771 15.3350725,12.058153 15.57,11.83 L18.87,8.61 L14.31,7.94 C13.9831235,7.89632826 13.6987948,7.69430528 13.55,7.4 L11.51,3.26 L9.47,7.4 C9.3231585,7.69165474 9.04317024,7.89324629 8.72,7.94 L4.15,8.61 L7.45,11.83 C7.68857105,12.056188 7.80072973,12.3851868 7.75,12.71 L6.96,17.26 L11.05,15.11 L11.05,15.11 Z",
  id: "Shape"
}))))));

var SvgStarOutline = function SvgStarOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStarOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star-outline.f71e4509.svg";
export { ForwardRef as ReactComponent };